import './style.css';

export interface Props {
  aspect: number;
  imageSrc: string;
}

export const InteractiveMap: React.FC<Props> = (props) => {
  return (
    <div
      className="interactivemap-container"
      style={{
        backgroundImage: `url(${props.imageSrc})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {props.children}
    </div>
  );
};
